import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import ellipseImage from "../images/Ellipse 9.png";
import ellipseImage2 from "../images/Ellipse 9 (1).png";
import { Headline1, Headline2 } from "../components/Headlines";
import Logo from "../logo.svg";
import linkedinicon from "../images/in.svg";
import xicon from "../images/x.svg";
import mailicon from "../images/mail.svg";
import { aboutData } from "../data";

const StyledComingSoon = styled.section`
  background-color: ${(props) => props.theme.darkBg1};
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 60px 30px;
  overflow: hidden;
`;

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
`;

const BrandLogo = styled.img`
  margin-bottom: 40px;
`;

const VideoWrap = styled.div`
  margin-top: 10px;
  max-width: 420px;
  width: 100%;
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 18px;
  margin-top: 40px;
`;

const SocialLink = styled.a`
  display: inline-flex;
`;

export default function ComingSoon() {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleVideoEnd = () => {
      video.playbackRate = -1;
      video.play();
    };

    const handleTimeUpdate = () => {
      if (video.currentTime <= 0.1 && video.playbackRate < 0) {
        video.playbackRate = 1;
        video.play();
      }
    };

    video.addEventListener("ended", handleVideoEnd);
    video.addEventListener("timeupdate", handleTimeUpdate);

    return () => {
      video.removeEventListener("ended", handleVideoEnd);
      video.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, []);

  return (
    <StyledComingSoon>
      <img
        style={{ position: "absolute", top: "0", right: "0", zIndex: "0" }}
        src={ellipseImage}
        alt=""
      />
      <img
        style={{ position: "absolute", bottom: "0", left: "0", zIndex: "0" }}
        src={ellipseImage2}
        alt=""
      />
      <ContentBox>
        <BrandLogo src={Logo} alt="Bubble Logo" width="64px" height="65px" />
        <Headline1>Coming Soon</Headline1>
        <Headline2>
          We're putting the finishing touches on something great. Our new site
          will be live shortly.
        </Headline2>
        <VideoWrap>
          <video
            ref={videoRef}
            width="100%"
            height="auto"
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={"/abstract-donut.mp4"} type="video/mp4" />
          </video>
        </VideoWrap>
        <SocialLinks>
          <SocialLink href={aboutData.linkedin}>
            <img src={linkedinicon} alt="LinkedIn" width="30px" height="30px" />
          </SocialLink>
          <SocialLink href={aboutData.x}>
            <img src={xicon} alt="X" width="30px" height="30px" />
          </SocialLink>
          <SocialLink href={`mailto:${aboutData.mail}`}>
            <img src={mailicon} alt="Email" width="30px" height="30px" />
          </SocialLink>
        </SocialLinks>
      </ContentBox>
    </StyledComingSoon>
  );
}
